import { jsx as _jsx } from "react/jsx-runtime";
import { useId } from '../../../hooks/useId/useId';
import { StyledScaleWrap, StyledScaledOption } from './sliderScaleStandAlone.styled';
/**
 * @description
 * SliderScaleStandAlone component is used to display a scale for the slider.
 */
export const SliderScaleStandAlone = ({ showScale, scaleOffsets, styles, }) => {
    const uniqueTickmarksId = useId('tickmarks');
    if (!showScale) {
        return null;
    }
    return (_jsx(StyledScaleWrap, { id: uniqueTickmarksId, styles: styles, children: scaleOffsets.map((scaleElementOffset, i) => {
            return (_jsx(StyledScaledOption, { scaleOffset: scaleElementOffset, styles: styles }, `${uniqueTickmarksId}_${i}`));
        }) }));
};
//# sourceMappingURL=sliderScaleStandAlone.js.map